<template>
  <div class="container">
    <div class="swagger" id="swagger"></div>
  </div>
</template>

<script>
import SwaggerUI from 'swagger-ui';
import 'swagger-ui/dist/swagger-ui.css';

export default {
  props: {
    file: String
  },
  name: 'Swagger',
  mounted() {
    SwaggerUI({
      url: this.$route.params.branch
          ? '/branch/' + this.$route.params.branch + '/' + this.file
          : '/yaml/' + this.file,
      dom_id: '#swagger',
      deepLinking: true,
      docExpansion: 'list',
      validatorUrl: null,
    });
  },
};
</script>
